import { regexExp } from '@business/rules/regex';
import * as yup from 'yup';

export const familyFormSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  relationshipType: yup
    .string()
    .when('$skipConditionalRequired', ([skipConditionalRequired]) => {
      return !Boolean(skipConditionalRequired)
        ? yup.string().required('Relationship type is required')
        : yup.string().notRequired();
    }),
  nickName: yup.string(),
  gender: yup
    .string()
    .when('$skipConditionalRequired', ([skipConditionalRequired]) => {
      return !Boolean(skipConditionalRequired)
        ? yup.string().required('Gender is required')
        : yup.string().notRequired();
    }),
  birthday: yup.string(),
  birthPlace: yup.string(),
  dadName: yup.string(),
  momName: yup.string(),
  spouseName: yup.string(),
  daughterName: yup.string(),
  sonName: yup.string(),
  stepdadName: yup.string(),
  email: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .test(
      'email-or-empty',
      'Please enter a valid email address',
      value => !value || regexExp.emailRegex.test(value)
    )
});
